const iconParkUrl = [
    'https://lf1-cdn-tos.bytegoofy.com/obj/iconpark/icons_24921_44.2b356b4384a63513cd22d0cc155e9c45.js',
    'https://lf1-cdn-tos.bytegoofy.com/obj/iconpark/icons_24921_42.00b77d22f304d3adef5df69a30002d45.js',
    // 2023年4月21日16:15:47 调研模板icon
    'https://lf1-cdn-tos.bytegoofy.com/obj/iconpark/icons_24921_35.10b048281c455be9a84aaa9bfe787dad.js',
    // 2023年4月15日15:46:58
    'https://lf1-cdn-tos.bytegoofy.com/obj/iconpark/icons_24921_25.0d9d8ff420c1625cac59251aabb6c317.js'
]
export default iconParkUrl[0]
